import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_ADD_QUERY_TO_COLLECTION_BEGIN,
  COLLECTIONS_ADD_QUERY_TO_COLLECTION_SUCCESS,
  COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE,
  COLLECTIONS_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function addQueryToCollection(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_ADD_QUERY_TO_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/finders/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_ADD_QUERY_TO_COLLECTION_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Created filter in collection');
            toast.success('Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE,
              data: { error: err },
            });
            Mixpanel.track('Failed to create filter in collection');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject(err);
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create filter in collection');
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Creation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddQueryToCollectionError() {
  return {
    type: COLLECTIONS_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_ADD_QUERY_TO_COLLECTION_BEGIN:
      return {
        ...state,
        addQueryToCollectionPending: true,
        addQueryToCollectionError: null,
      };

    case COLLECTIONS_ADD_QUERY_TO_COLLECTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        addQueryToCollectionPending: false,
        addQueryToCollectionError: null,
        selectedCollection: action.data,
        projectCollections,
      };

    case COLLECTIONS_ADD_QUERY_TO_COLLECTION_FAILURE:
      return {
        ...state,
        addQueryToCollectionPending: false,
        addQueryToCollectionError: action.data.error,
      };

    case COLLECTIONS_ADD_QUERY_TO_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        addQueryToCollectionError: null,
      };

    default:
      return state;
  }
}
